import { render, staticRenderFns } from "./kdBasicInfo.vue?vue&type=template&id=2c2ce957"
import script from "./kdBasicInfo.vue?vue&type=script&lang=js"
export * from "./kdBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports